import React from 'react';
import {
  SettingOutlined,
  ScheduleOutlined,
  FormOutlined,
  AppstoreOutlined,
  DollarOutlined,
  TeamOutlined,
  SolutionOutlined,
  SwitcherOutlined,
  AreaChartOutlined,
  DashboardFilled,
  ShoppingCartOutlined,
  PlusCircleOutlined,
  UnorderedListOutlined,
  RollbackOutlined,
  TagsOutlined,
  InboxOutlined,
  UserOutlined,
  ShopOutlined,
  IdcardOutlined,
  WalletOutlined,
  GiftOutlined,
  PieChartOutlined,
  CalendarOutlined,
  BarChartOutlined,
  ShoppingOutlined,
  UsergroupAddOutlined,
  AccountBookOutlined,
  MessageOutlined,
  BankOutlined,
  UserSwitchOutlined,
  SafetyOutlined,
  KeyOutlined,
  QuestionCircleOutlined,
  BookOutlined,
  RocketOutlined,
  FundOutlined,
  CarOutlined,
  ScanOutlined,
  LaptopOutlined,
  AuditOutlined,
  RobotOutlined,
  NotificationOutlined,
  DollarCircleOutlined,
} from '@ant-design/icons';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  /** permission controller:action required to see this item (thiếu → chỉ super user thấy) */
  permissionKey?: string;
  /** luôn hiển thị, không cần quyền (vd Trợ giúp) */
  public?: boolean;
  /** `false` → không chọn làm trang đích sau đăng nhập (vd trang tạo mới) */
  landing?: boolean;
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'Tổng quan',
    key: 'nft-dashboard',
    url: '/',
    icon: <DashboardFilled />,
  },
  {
    title: 'Đơn hàng',
    key: 'orders',
    icon: <ShoppingCartOutlined />,
    children: [
      {
        title: 'Tạo đơn hàng',
        key: 'orders-new',
        url: 'orders/new',
        icon: <PlusCircleOutlined />,
        permissionKey: 'orders:create',
        landing: false,
      },
      {
        title: 'Đơn hàng',
        key: 'orders-list',
        url: 'orders/list',
        icon: <UnorderedListOutlined />,
        permissionKey: 'orders:index',
      },
      {
        title: 'Đơn hàng trả về',
        key: 'order-returns/list',
        url: 'order-returns/list',
        icon: <RollbackOutlined />,
        permissionKey: 'orders:index',
      },
      {
        title: 'Chuyến giao hàng',
        key: 'delivery-trips',
        url: 'delivery-trips',
        icon: <CarOutlined />,
        permissionKey: 'delivery_trips:index',
      },
      {
        title: 'Quét mã đơn',
        key: 'scan-order',
        url: 'scan',
        icon: <ScanOutlined />,
        permissionKey: 'orders:show',
        landing: false,
      },
    ],
  },
  {
    title: 'Tin nhắn',
    key: 'inbox',
    url: 'inbox',
    icon: <MessageOutlined />,
    permissionKey: 'messaging/conversations:index',
  },
  {
    title: 'Quản lý kho',
    key: 'inventory',
    icon: <SwitcherOutlined />,
    children: [
      {
        title: 'Sản phẩm',
        key: 'products',
        url: 'inventory/products/list',
        icon: <TagsOutlined />,
        permissionKey: 'products:index',
      },
      {
        title: 'Quản lý kho',
        key: 'movement',
        url: 'inventory/movements/list',
        icon: <InboxOutlined />,
        permissionKey: 'movements:index',
      },
    ],
  },
  {
    title: 'Sổ cái',
    key: 'ledger',
    url: '/ledgers/list',
    icon: <DollarOutlined />,
    permissionKey: 'ledgers:index',
  },
  {
    title: 'Đối tác',
    key: 'partners',
    icon: <SolutionOutlined />,
    children: [
      {
        title: 'Khách hàng',
        key: 'customers',
        url: 'partners/customers/list',
        icon: <UserOutlined />,
        permissionKey: 'customers:index',
      },
      {
        title: 'Nhà cung cấp',
        key: 'suppliers',
        url: 'partners/suppliers/list',
        icon: <ShopOutlined />,
        permissionKey: 'suppliers:index',
      },
    ],
  },
  {
    title: 'Marketing',
    key: 'marketing',
    icon: <NotificationOutlined />,
    children: [
      {
        title: 'Báo cáo marketing',
        key: 'reports-marketing',
        url: 'reports/marketing',
        permissionKey: 'reports/marketing:index',
        icon: <FundOutlined />,
      },
      {
        title: 'Chi phí quảng cáo',
        key: 'marketing-ad-spends',
        url: 'marketing/ad-spends',
        permissionKey: 'marketing/ad_spends:index',
        icon: <DollarCircleOutlined />,
      },
    ],
  },
  {
    title: 'Nhân viên',
    key: 'employees',
    icon: <TeamOutlined />,
    children: [
      {
        title: 'Nhân viên',
        key: 'employees-list',
        url: 'employees/list',
        icon: <IdcardOutlined />,
        permissionKey: 'employees:index',
      },
      {
        title: 'Chấm công',
        key: 'timesheets',
        url: 'employees/timesheets',
        icon: <ScheduleOutlined />,
      },
      {
        title: 'Đơn nghỉ phép',
        key: 'leave-requests',
        url: 'employees/leave-requests',
        icon: <FormOutlined />,
      },
      {
        title: 'Lịch nghỉ',
        key: 'leave-calendar',
        url: 'employees/leave-calendar',
        icon: <CalendarOutlined />,
      },
      {
        title: 'Lương',
        key: 'salaries',
        url: 'employees/salaries',
        icon: <WalletOutlined />,
      },
      {
        title: 'Bonus',
        key: 'bonus',
        url: 'employees/bonus',
        icon: <GiftOutlined />,
      },
    ],
  },
  {
    title: 'Báo cáo',
    key: 'reports',
    icon: <AreaChartOutlined />,
    children: [
      {
        title: 'Tổng quan',
        key: 'reports-dashboard',
        url: 'reports/dashboard',
        permissionKey: 'reports/dashboard:index',
        icon: <PieChartOutlined />,
      },
      {
        title: 'Báo cáo cuối ngày',
        key: 'reports-end-of-last-day',
        url: 'reports/end-of-last-day',
        permissionKey: 'reports/end_of_day:index',
        icon: <CalendarOutlined />,
      },
      {
        title: 'Báo cáo bán hàng',
        key: 'reports-order',
        url: 'reports/order',
        permissionKey: 'reports/order:index',
        icon: <BarChartOutlined />,
      },
      {
        title: 'Báo cáo theo hàng hoá',
        key: 'reports-product',
        url: 'reports/product',
        permissionKey: 'reports/inventory:index',
        icon: <ShoppingOutlined />,
      },
      {
        title: 'Báo cáo tồn kho',
        key: 'reports-stock',
        url: 'reports/stock',
        permissionKey: 'reports/stock:index',
        icon: <InboxOutlined />,
      },
      {
        title: 'Báo cáo theo khách hàng',
        key: 'reports-customer',
        url: 'reports/customer',
        permissionKey: 'reports/customer:index',
        icon: <UsergroupAddOutlined />,
      },
      {
        title: 'Báo cáo tài chính',
        key: 'reports-finance',
        url: 'reports/finance',
        permissionKey: 'reports/finance:index',
        icon: <AccountBookOutlined />,
      },
      {
        title: 'Tin nhắn Zalo',
        key: 'reports-zalo-messages',
        url: 'reports/zalo-messages',
        permissionKey: 'reports/zalo_message:index',
        icon: <MessageOutlined />,
      },
    ],
  },
  {
    title: 'Cài đặt',
    key: 'settings',
    icon: <SettingOutlined />,
    children: [
      {
        title: 'Cài đặt chung',
        key: 'generals',
        icon: <AppstoreOutlined />,
        url: 'settings/generals',
        permissionKey: 'app_settings:index',
      },
      {
        title: 'Ngân hàng',
        key: 'banks',
        url: 'settings/banks',
        icon: <BankOutlined />,
        permissionKey: 'banks:index',
      },
      {
        title: 'Người dùng',
        key: 'users',
        url: 'settings/users',
        icon: <UserSwitchOutlined />,
        permissionKey: 'users:index',
      },
      {
        title: 'Vai trò',
        key: 'roles',
        url: 'settings/roles',
        icon: <SafetyOutlined />,
        permissionKey: 'roles:index',
      },
      {
        title: 'Phân quyền',
        key: 'permissions',
        url: 'settings/permissions',
        icon: <KeyOutlined />,
        permissionKey: 'permissions:index',
      },
      {
        title: 'Phiên đăng nhập',
        key: 'sessions',
        url: 'settings/sessions',
        icon: <LaptopOutlined />,
        permissionKey: 'user_sessions:index',
      },
      {
        title: 'Kênh nhắn tin',
        key: 'messaging-channels',
        url: 'settings/messaging-channels',
        icon: <MessageOutlined />,
        permissionKey: 'messaging/channels:manage',
      },
      {
        title: 'Trả lời tự động',
        key: 'messaging-auto-replies',
        url: 'settings/messaging-auto-replies',
        icon: <RobotOutlined />,
        permissionKey: 'messaging/auto_reply_rules:manage',
      },
      {
        title: 'Audit log',
        key: 'audit-log',
        url: 'settings/audit-log',
        icon: <AuditOutlined />,
        permissionKey: 'audit_events:index',
      },
    ],
  },
  {
    // Quyền từng mục xem KEY_RULES trong navigationAccess.ts.
    title: 'My',
    key: 'my',
    icon: <UserOutlined />,
    children: [
      {
        title: 'Báo cáo của tôi',
        key: 'my-report',
        url: 'sales-dashboard',
        icon: <BarChartOutlined />,
      },
      {
        title: 'Lương của tôi',
        key: 'my-salary',
        url: 'my-salary',
        icon: <WalletOutlined />,
      },
      {
        title: 'Bonus của tôi',
        key: 'my-bonus',
        url: 'my-bonus',
        icon: <GiftOutlined />,
      },
    ],
  },
  {
    title: 'Trợ giúp',
    key: 'help',
    icon: <QuestionCircleOutlined />,
    children: [
      {
        title: 'Hướng dẫn sử dụng',
        key: 'help-guide',
        url: 'help/guide',
        icon: <BookOutlined />,
        public: true,
      },
      {
        title: 'Nhật ký cập nhật',
        key: 'help-releases',
        url: 'help/releases',
        icon: <RocketOutlined />,
        public: true,
      },
    ],
  },
  //end THV

  // {
  //   title: 'common.authPages',
  //   key: 'auth',
  //   icon: <UserOutlined />,
  //   children: [
  //     {
  //       title: 'common.login',
  //       key: 'login',
  //       url: '/auth/login',
  //     },
  //     {
  //       title: 'common.signUp',
  //       key: 'singUp',
  //       url: '/auth/sign-up',
  //     },
  //     {
  //       title: 'common.lock',
  //       key: 'lock',
  //       url: '/auth/lock',
  //     },
  //     {
  //       title: 'common.forgotPass',
  //       key: 'forgotPass',
  //       url: '/auth/forgot-password',
  //     },
  //     {
  //       title: 'common.securityCode',
  //       key: 'securityCode',
  //       url: '/auth/security-code',
  //     },
  //     {
  //       title: 'common.newPassword',
  //       key: 'newPass',
  //       url: '/auth/new-password',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.charts',
  //   key: 'charts',
  //   url: '/charts',
  //   icon: <LineChartOutlined />,
  // },
  // {
  //   title: 'common.maps',
  //   key: 'maps',
  //   icon: <CompassOutlined />,
  //   children: [
  //     {
  //       title: 'common.googleMap',
  //       key: 'google-maps',
  //       url: '/maps/google-maps',
  //     },
  //     {
  //       title: 'common.leafletMap',
  //       key: 'leaflet-maps',
  //       url: '/maps/leaflet-maps',
  //     },
  //     {
  //       title: 'common.reactSimpleMaps',
  //       key: 'react-simple-maps',
  //       url: '/maps/react-simple-maps',
  //     },
  //     {
  //       title: 'common.pigeonMaps',
  //       key: 'pigeon-maps',
  //       url: '/maps/pigeon-maps',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.pages',
  //   key: 'pages',
  //   icon: <LayoutOutlined />,
  //   children: [
  //     {
  //       title: 'common.profilePage',
  //       key: 'profile',
  //       url: '/profile',
  //     },
  //     {
  //       title: 'common.serverError',
  //       key: 'serverError',
  //       url: '/server-error',
  //     },
  //     {
  //       title: 'common.clientError',
  //       key: '404Error',
  //       url: '/404',
  //     },
  //   ],
  // }
];
